function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.4167 18.25V3.58333C16.4167 2.57081 15.5959 1.75 14.5833 1.75H5.41667C4.40414 1.75 3.58333 2.57081 3.58333 3.58333V18.25M16.4167 18.25L18.25 18.25M16.4167 18.25H11.8333M3.58333 18.25L1.75 18.25M3.58333 18.25H8.16667M7.25 5.41665H8.16667M7.25 9.08331H8.16667M11.8333 5.41665H12.75M11.8333 9.08331H12.75M8.16667 18.25V13.6666C8.16667 13.1604 8.57707 12.75 9.08333 12.75H10.9167C11.4229 12.75 11.8333 13.1604 11.8333 13.6666V18.25M8.16667 18.25H11.8333",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.1aa61bac.svg";
export { ForwardRef as ReactComponent };